import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import EventsMenu from '../components/events/EventsMenu.vue';
import EventsList from '../components/events/EventsList.vue';
import { useRoute } from 'vue-router';
import EventsSourcesList from '@/components/events/EventsSourcesList.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'EventsView',
  setup(__props) {

const route = useRoute();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(EventsMenu),
    (_unref(route).path === '/events')
      ? (_openBlock(), _createBlock(EventsList, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(route).path === '/events/sources')
      ? (_openBlock(), _createBlock(EventsSourcesList, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})